/**
 * Read-Only Mode Banner
 * Displays when subscription is expired/paused
 */

import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const ReadOnlyBanner: React.FC = () => {
  const { user } = useAuth();
  
  // Only show if user is in read-only mode
  if (!user?.is_read_only) {
    return null;
  }

  return (
    <div className="bg-yellow-50 border-b border-yellow-200 px-4 py-3 shadow">
      <div className="max-w-7xl mx-auto flex items-center justify-center text-sm">
        <AlertTriangle className="h-4 w-4 text-yellow-600 mr-2 flex-shrink-0" />
        <span className="text-yellow-800 font-medium mr-2">
          Your subscription is paused. Your account is in read-only mode.
        </span>
        <Link 
          to="/subscription" 
          className="text-yellow-900 underline hover:text-yellow-700 font-semibold"
        >
          Reactivate Subscription
        </Link>
      </div>
    </div>
  );
};

export default ReadOnlyBanner;

